import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Img } from 'src/app/core/models/DigitalKit';
import $ from 'jquery';
import 'bootstrap';

interface Card {
  title: string;
  text: string;
}

@Component({
  selector: 'app-digital-growth-project',
  templateUrl: './digital-growth-project.component.html',
  styleUrls: ['./digital-growth-project.component.css'],
  standalone: false
})
export class DigitalGrowthProjectComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | Proyecto de Estrategia y Crecimiento Digital');

    (<any>$('.carousel')).carousel();
  }

  cards: Card[] = [
    {
      title: 'RETO',
      text: 'Dificultad para captar clientes de forma eficiente en canales digitales, con baja visibilidad de marca y estrategias poco orientadas a resultados.'
    },
    {
      title: 'OBJETIVO',
      text: 'Incrementar la captación de leads cualificados, mejorar la conversión y posicionar la marca en el entorno digital de forma competitiva.'
    },
    {
      title: 'SOLUCIÓN',
      text: 'Definición y ejecución de estrategias de marketing digital basadas en datos: campañas de adquisición, optimización de conversiones (CRO), posicionamiento SEO y gestión de canales digitales orientados a rendimiento.'
    }
  ];

  carousels: Img[] = [
    {
      src: 'assets/img/microsoft.png',
      alt: 'Microsoft'
    },
    {
      src: 'assets/img/hubspot.webp',
      alt: 'HubSpot'
    },
    {
      src: 'assets/img/imagenOffice.png',
      alt: 'Microsoft 365'
    },
    {
      src: 'assets/img/marketing.webp',
      alt: 'Marketing Digital'
    },
  ];


}
